//require('@/assets/theme/plugins/global/plugins.bundle.css');
//require('@/assets/theme/css/style.bundle.css');
require('@/shared/assets/css/global.css');
require('@/assets/css/custom.css');